import styled from 'styled-components';
import { Input, Button } from 'antd';

export const SettingsButton = styled(Button)`
	padding: 0;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	&.ant-btn:focus,
	&.ant-btn:active {
		color: #262626 !important;
		background: transparent !important;
	}

	&.ant-btn:hover {
		color: #2f54eb !important;
		background: transparent !important;
	}

	&.ant-btn {
		padding: 0;
		border-radius: 4px;
	}

	&.ant-btn-icon-only {
		padding: 0;
	}

	color: #262626;
`;

export const SearchInput = styled(Input)`
	border-radius: 4px;
	padding: 8px;
`;

export const FilterIconStyled = styled.svg`
	width: 1.5em;
	height: 1.5em;
`;
